export class AddressLookupRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing address lookup request");
        }
        if (!request.personalNumber) {
            throw new Error("Missing personal number in address lookup request");
        }
    }
    forCustomer(personalNumber) {
        this.properties.personalNumber = personalNumber;
        return this;
    }
    build() {
        return this.properties;
    }
}
